<template>
  <div class="container">
    <!-- 搜索框 -->
    <section class="search_main">
    <section class="search_box" @click="toSearch" v-if="policyList.length && loaded">
      <img src="../../assets/images/search.png" />
      <span>搜索政策关键字</span>
    </section>
    </section>
    <ul class="list_box" v-if="policyList.length && loaded">
      <li @click="toModal(item)" v-for="(item,index) in policyList" :key="index">
        <img :src="item.imgUrl" />
        <span>{{item.typeName}}</span>
      </li>
    </ul>
    <no-message class="no_mess" v-if="!policyList.length && loaded"></no-message>
    <!-- 我的咨询 -->
    <section class="consultation" @click="myConsultation">
      <img src="../../assets/images/icon_consult.png" alt />
      <span>我的咨询</span>
    </section>
  </div>
</template>

<script>
import { getPolicyTypeByMarketId } from "../../utils/api";
import { mapState } from 'vuex';
import NoMessage from '../../components/nomessage';
import util from "../../utils/util";
export default {
  name: "policyServices",
  data(){
      return {
          policyList:[],
          loaded:false
      }
  },
  components:{
    NoMessage
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created(){
      this.getPolicyTypeByMarketId()
  },
  methods:{
      getPolicyTypeByMarketId(){
          util.showLoading()
          getPolicyTypeByMarketId({marketId:this.common.marketInfo.id}).then(res=>{
              console.log(res)
              this.loaded = true;
              if(res.res.code === 10000){
                  this.policyList = res.body.policyTypes
              }
              util.hideLoading()
          })
      },
      toSearch(){
          this.$router.push('/policySearch')
      },
      toModal(item){
        if(item.isCount && item.isCount != 0){
          this.$router.push(`/policyDetail?id=${item.isCount}`);
        }else{
          this.$router.push(`/policyList?typeCode=${item.typeCode}`)
        }
      },
      myConsultation(){
          this.$router.push('/myconsultation')
      }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #fff;
}
.search_main{
  padding: 26px 28px;
  background:#fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.search_box {
  height: 68px;
  width:100%;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px;
  .flex();
  align-items: center;
  img {
    display: block;
    width: 44px;
    height: 44px;
    margin: 0 16px 0 14px;
  }
  span {
    font-size: 28px;
    color: rgba(201, 201, 201, 1);
  }
}
.list_box {
  margin-top: 122px;
  .flex();
  padding: 42px 0;
  li {
    width: 25%;
    .flex();
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;
    img {
      display: block;
      width: 120px;
      height: 120px;
      margin-bottom: 28px;
      border-radius: 100%;
    }
    span {
      display: block;
      height: 40px;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      .textOver(90%);
    }
  }
}
.consultation {
  position: fixed;
  z-index:2;
  bottom: 78px;
  right: 0;
  width: 120px;
  height: 120px;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px 0px 0px 8px;
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    display: block;
    width: 36px;
    height: 36px;
    margin-bottom: 4px;
  }
  span {
    font-size: 22px;
    color: rgba(102, 102, 102, 1);
    line-height: 32px;
  }
}
.no_mess{
  height:100vh;
}
</style>